import {
  registerComponent,
  replaceDOM,
  asyncRequest,
  debounce,
  loading,
  getComponentConfig,
} from "helpers";

registerComponent(
  "cart-items",
  class CartItems extends HTMLElement {
    SECTIONS_TO_RENDER = [
      {
        name: "cart-count",
        selector: "[data-cart-count]",
      },
      {
        name: "cart",
        selector: "[data-free-shipping-message]",
      },
      {
        name: "cart",
        selector: "[data-cart-items]",
      },
      {
        name: "cart",
        selector: "[data-cart-totals]",
      },
      {
        name: "cart",
        selector: "[data-cart-rewards]",
      },
      {
        name: "cart",
        selector: "[data-cart-checkout]",
      },
      {
        name: "cart",
        selector: "[data-cart-recommendations]",
      },
    ];

    constructor() {
      super();

      this.config = getComponentConfig(this);

      this.removeButtons = this.querySelectorAll("[data-remove-item-button]");
      this.form = this.querySelector("form");

      this.removeButtons.forEach((button) => {
        button.addEventListener("click", this.remove.bind(this));
      });

      const debouncedChangeHandler = debounce((event) => {
        this.handleChange(event);
      }, 300);

      this.form?.addEventListener("change", debouncedChangeHandler);
    }

    remove(event) {
      event.preventDefault();

      this.updateQuantity(event.currentTarget.dataset.removeItemButton, 0);
    }

    handleChange(event) {
      this.updateQuantity(event.target.dataset.key, event.target.value);
    }

    getSectionNames() {
      return [
        ...new Set(this.SECTIONS_TO_RENDER.map((section) => section.name)),
      ];
    }

    buildUpdates(itemKey, newQuantity) {
      const updates = {};
      let total = 0;

      this.config.items.forEach((item) => {
        if (item.price === 0) {
          return;
        }

        const quantity =
          item.key === itemKey ? parseInt(newQuantity, 10) : item.quantity;

        updates[item.key] = quantity;

        total += item.price * quantity;
      });

      const promotionalItems = this.config.items.filter(
        (item) => item.promotionalThreshold,
      );

      if (promotionalItems) {
        promotionalItems.forEach((item) => {
          if (item.promotionalThreshold > total) {
            updates[item.key] = 0;
          }
        });
      }

      return updates;
    }

    async updateQuantity(key, quantity) {
      const body = {
        updates: this.buildUpdates(key, quantity),
        sections: this.getSectionNames(),
        sections_url: window.location.pathname,
      };
      const options = {
        ...WYATT.config.fetch.post,
        ...{ body: JSON.stringify(body) },
      };

      loading.add(this);

      const response = await asyncRequest(
        WYATT.routes.cart_update_url,
        options,
        {
          messageOptions: {
            minDelay: 6000,
            appendPoint:
              '[data-mini-cart][active="true"] [data-drawer-messages], #page-messages',
          },
        },
      );

      if (response) {
        this.handleSuccessfulUpdate(response);
      }

      loading.remove(this);
    }

    handleSuccessfulUpdate(state) {
      const parsedState = JSON.parse(state);

      this.SECTIONS_TO_RENDER.forEach((section) =>
        replaceDOM(parsedState.sections[section.name], section.selector),
      );
    }
  },
);
